export const LOAD_REQUESTED = "TOUR/LOAD_REQUESTED";
export const LOAD_SUCCESS = "TOUR/LOAD_SUCCESS";
export const LOAD_FAIL = "TOUR/LOAD_FAIL";

export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadtour = data => ({ type: LOAD_REQUESTED, data });
export const successLoadtour = data => ({ type: LOAD_SUCCESS, data });
export const failLoadtour = data => ({ type: LOAD_FAIL, data });
